import React, { Component } from 'react';
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import FilterPanel from "../../components/panels/FilterPanel";
import {List, fromJS} from "immutable";
import StockItemsList from "./views/StockItemsList";
import MovementsList from "./views/MovementsList";
import {getAllWarehouses, addAllWarehousesOption} from "../../lib/Warehouses";

const productFilterOptions = fromJS([
  {id: "", label: "All Products"},
  {id: "water", label: "Water"},
  {id: "dispenser", label: "Dispensers"},
  {id: "extras", label: "Extras"},
  {id: "packaging", label: "Packaging"}
])

const viewOptions = fromJS([
  {id: "", label: "Products"},
  {id: "movements", label: "Movements"},
])

class StockPage extends Component {

  constructor(props) {
    super(props);

    // Can't check yet if the id is in the list of accessible warehouse ids
    // as that data is populated after the initial render of the page
    const defaultWarehouseFilter = props.router.location.query.warehouse_id || "";

    this.state = {
      warehouseFilter: defaultWarehouseFilter,
      productFilter: "",
      view: ""
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // If accessible warehouse ids is ready or the warehouse filter has changed,
    // we need to ensure the filter validity
    if ((!this.restrictWarehouseIds(prevProps) && this.restrictWarehouseIds(this.props))
      || (prevState.warehouseFilter !== this.state.warehouseFilter)) {
      // Ensures that the warehouse filter is valid
      if (this.restrictWarehouseIds() && !this.props.accessibleWarehouseIds.includes(this.state.warehouseFilter)) {
        this.setState({warehouseFilter: this.props.accessibleWarehouseIds.first()});
      }
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Warehouse Stock";

    return (
      <div className="StockPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Add Stock" 
              onClick={this.handleAddStock.bind(this)}
               />          
            <ActionButton 
              label="Remove Stock" 
              onClick={this.handleRemoveStock.bind(this)}
               />          
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {

    switch(this.state.view) {
      case "movements":
        return (
          <MovementsList
            warehouseFilter={this.state.warehouseFilter}
            />
        )

      default:
        return (
          <StockItemsList
            warehouseFilter={this.state.warehouseFilter}
            productFilter={this.state.productFilter}
            />
        )
    }
  }

  renderPanels(page) {
    switch(page) {
      default:
        return this.buildPanels(List(["viewOptions", "productFilter", "warehouseFilter"]));
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "viewOptions":
        return <FilterPanel
          key="ViewOptionsPanel"
          title="View"
          expanded={true}
          options={viewOptions}
          onClick={this.handleChangeView.bind(this)}
          filter={this.state.view}
          />

      case "productFilter":
        return <FilterPanel
          key="ProductFilterPanel"
          title="Product Filter"
          expanded={true}
          options={productFilterOptions}
          onClick={this.handleSetProductFilter.bind(this)}
          filter={this.state.productFilter}
          />              

      case "warehouseFilter":
        let warehouses = getAllWarehouses();
        warehouses = addAllWarehousesOption(warehouses);

        // User might be restricted into which warehouses they can see
        if (this.props.accessibleWarehouseIds.size > 0) {
          warehouses = warehouses.filter((w) => this.props.accessibleWarehouseIds.includes(w.get("id")));
        }

        return <FilterPanel
          key="WarehouseFilterPanel"
          title="Warehouse Filter"
          expanded={true}
          options={warehouses}
          onClick={this.handleSetWarehouseFilter.bind(this)}
          filter={this.state.warehouseFilter}
          />        

      default:
        return null;
    }
  }

  handleSetWarehouseFilter(item) {
    this.setState({
      warehouseFilter: item.get("id")
    });
  }  

  handleSetProductFilter(item) {
    this.setState({
      productFilter: item.get("id")
    });
  }  

  handleChangeView(item) {
    this.setState({
      view: item.get("id")
    });
  }

  handleAddStock() {
    this.props.requestAddStock(this.state.warehouseFilter);
  }

  handleRemoveStock() {
    this.props.requestRemoveStock(this.state.warehouseFilter);
  }

  restrictWarehouseIds(maybeProps = null) {
    return (maybeProps || this.props).accessibleWarehouseIds.size > 0;
  }
}

export default StockPage;